import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { AdminApplicantPage } from './AdminApplicantPage';

export function AdminApplicantRouteWrapper() {
  const { uid, subsurvey } = useParams<{ uid: string; subsurvey?: string }>();

  return (
    <AdminApplicantPage
      uid={uid}
      subsurvey={subsurvey}
    />
  );
}
